export default function WeatherReportRecommendations({ recommendations = [] }) {
  if (!recommendations.length) {
    return null;
  }

  return (
    <section className="panel-card weather-report-recommendations">
      <p className="eyebrow">Recommendations</p>
      <ul>
        {recommendations.map((row) => (
          <li key={row.text}>{row.text}</li>
        ))}
      </ul>
    </section>
  );
}
